import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

export interface FilterState {
    page?: number | string;
    limit?: number | string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc' | string;

    search?: string;
}

export const normalizeFilterInput = (filters: FilterState) => ({
    ...filters,
    page: filters.page ? Number(filters.page) : undefined,
    limit: filters.limit ? Number(filters.limit) : undefined,
});

const FilterProvider = ({ children }: { children: React.ReactNode }) => {
    const form = useForm<FilterState>({
        defaultValues: {
            page: 1,
            limit: 50
        }
    });

    return (
        <FormProvider {...form}>
            {children}
        </FormProvider>
    )
}

export default FilterProvider